import { generateServiceNavItems } from './services';
import { NavItem } from '../types/navigation';

export const NAV_ITEMS: NavItem[] = [
  { 
    name: 'services',
    label: 'Services',
    to: '/services'
  },
  { 
    name: 'locations',
    label: 'Locations',
    to: '/locations'
  },
  ...generateServiceNavItems(),
  { 
    name: 'blog',
    label: 'Blog',
    to: '/blog'
  },
  { 
    name: 'about',
    label: 'About',
    to: '/about' 
  },
  {
    name: 'invoices',
    label: 'Invoices',
    to: '/invoices'
  },
  {
    name: 'inventory',
    label: 'Inventory',
    to: '/inventory',
    icon: 'Package'
  },
  {
    name: 'payments',
    label: 'Payments',
    to: '/payments'
  },
  {
    name: 'admin-users',
    label: 'User Management',
    to: '/admin/users',
    icon: 'Users'
  },
  {
    name: 'admin-blog',
    label: 'Blog Management',
    to: '/admin/blog',
    icon: 'Document'
  }
];

export const SITE_NAME = 'Plaza Muffler & Hitches';